import React from "react";
import PaymentIcons from "../molecules/PaymentIcons";
import LockIcon from "../../images/icons/LockIcon"
export default function Footer() {
  return (
    <footer className="flex w-full justify-between items-center text-xs	bg-black text-white h-auto pl-1 pb-1 mt-2 sticky bottom-0">
      <div className="flex w-3/5 justify-between">
        <h4 className="flex w-3/4" >Métodos de pago</h4>
        <PaymentIcons />
      </div>

      <div className="flex items-center h-6">
        <h4>Aviso de privacidad</h4>
        <LockIcon 
          width="24" 
          height="25"
          fill="white"
          className="flex justify-center" 
        />
      </div>
    </footer>
  );
}
